// extracted by mini-css-extract-plugin
export default {"root":"orderSummary_root__V7zNx","item":"orderSummary_item__jf4+M"};